import { ArrowBack, Close, Menu } from "@mui/icons-material";
import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import logo from "../../assets/images/logo_smaart_green.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import LogoutButton from "../buttons/logoutButton.component";
import { useLogout } from "../../utils/logoutUtils";
import MobileMenuList from "./mobileMenuList.component";
import { MobileMenuIconsStyles } from "../../styles/commonStyles";

const logoutIconStyle = {
  width: "20px",
  height: "20px",
  color: "black",
  marginRight: 4,
};
const logoutButtonStyle = () => ({
  color: "black",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "18px",
  marginLeft: 4,
});

const MobileMenu = ({ feVersion, userType }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleLogout } = useLogout();

  const [openMenu, setOpenMenu] = useState(false);

  const isAdmin = userType === "Admin";
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const isDetailPage =
    pathSegments[0] === "admin"
      ? pathSegments.length > 2
      : pathSegments.length >= 2;

  const handleOpenMenu = () => {
    setOpenMenu((prev) => !prev);
  };

  const handleBack = () => {
    const mainPath =
      pathSegments[0] === "admin"
        ? `/${pathSegments.slice(0, 2).join("/")}`
        : `/${pathSegments[0]}`;
    navigate(mainPath);
  };

  useEffect(() => {
    setOpenMenu(false);
  }, [location.pathname]);

  return (
    <Box
      width="100%"
      height={openMenu ? "100%" : "80px"}
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 10,
        backgroundColor: "white",
        boxShadow: "0 3px 9px rgba(0,0,0,0.08)",
      }}
      overflow="auto"
    >
      <Stack direction="column" height="100%">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "80px",
            px: 3,
          }}
        >
          <IconButton
            aria-label="open-menu"
            onClick={isDetailPage ? handleBack : handleOpenMenu}
          >
            {isDetailPage ? (
              <ArrowBack sx={MobileMenuIconsStyles} />
            ) : openMenu ? (
              <Close sx={MobileMenuIconsStyles} />
            ) : (
              <Menu sx={MobileMenuIconsStyles} />
            )}
          </IconButton>
          <Box
            component="img"
            src={logo}
            alt="Logo Smaart"
            sx={{ width: 132, height: 23 }}
          />
          <Box sx={{ width: 40, height: 40 }} />
        </Box>
        {openMenu && (
          <Box height="100%" width="100%" px={2}>
            <Divider
              sx={{
                marginBottom: 2,
                backgroundColor: "#E0E0E0",
                height: "1px",
              }}
            />
            <MobileMenuList userType={userType} />
            <Box width="100%" marginTop={isAdmin ? 20 : 40}>
              <LogoutButton
                handleLogout={handleLogout}
                iconStyle={logoutIconStyle}
                buttonStyle={logoutButtonStyle}
                isDrawerOpen={true}
              />
            </Box>
            <Divider
              sx={{ marginTop: 3, backgroundColor: "#E0E0E0", height: "1px" }}
            />
            <Box width="100%" p={3}>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  marginLeft: 1,
                }}
                color="#707070"
              >{`Versione ${feVersion}`}</Typography>
            </Box>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default MobileMenu;
